module.exports = __webpack_public_path__ + "static/media/social-share.a0238130.jpg";